/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, take } from 'rxjs';

import { getAllPathParams } from '../get-all-path-params';
import { AppState } from 'src/app/state/app.state';
import { workspaceListFeature } from '@workspaces/store/workspace-list.feature';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceDeletedGuard {
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly store: Store<AppState>,
    private readonly snackbar: MatSnackBar
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const pathParams = getAllPathParams(route);
    const canActivate = this.getWorkspaceDeletedStatus(pathParams['workspaceId']);
    return canActivate.pipe(
      map(canActivate => {
        if (!canActivate) {
          this.snackbar.open("Can't open deleted workspace!", 'Dismiss', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
          return false;
        }
        return true;
      }),
      take(1)
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  getWorkspaceDeletedStatus(workspaceId: string) {
    return combineLatest([
      this.store.select(workspaceListFeature.selectData).pipe(filter(workspaces => workspaces.length !== 0)),
      this.store.select(workspaceListFeature.workspaceListsIsLoading)
    ]).pipe(
      filter(([_workspaceData, isLoading]) => !isLoading),
      map(([workspaceData]) => {
        const currentWorkSpace = workspaceData.find(workspace => {
          return workspace.id === workspaceId;
        });

        if (!currentWorkSpace) {
          return undefined;
        }
        return !currentWorkSpace.is_deleted;
      })
    );
  }
}
